var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_delete_24px",
    className: "cls-2",
    d: "M5.942,18.076A1.89,1.89,0,0,0,7.827,19.96h7.538a1.89,1.89,0,0,0,1.884-1.884V6.769H5.942ZM18.191,3.942h-3.3L13.951,3H9.24L8.3,3.942H5V5.827H18.191Z",
    transform: "translate(-3 -3)",
    fill: "#09819A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.89cfd22e00a14c24a2568bf83cdfc9d3.svg";
export { ForwardRef as ReactComponent };